export default __webpack_public_path__ + "static/media/gem-banner.cbdcd101.png";